import React from 'react'
import { Background, RootCon } from './styles'
import { AllStarContainer } from './components/AllStarContainer'
import { PageHeader } from '../../Components/Headers'
import { AllStarBoxscore } from './components/AllStarBoxscore/AllStarBoxscore'
import { ALL_STAR_BANNER } from './consts'
import { VoteHeadSection } from '../AllStarVote/styles'
import { AdUnit } from '../../Components/Ads/AdUnit'

const AllStar: React.FC<React.PropsWithChildren<unknown>> = () => {

  return (
    <>
      <Background />
      <RootCon>
        <VoteHeadSection>
          <PageHeader
            banner={ALL_STAR_BANNER}
            img={ALL_STAR_BANNER!.topUrl}
            link={ALL_STAR_BANNER?.topLink}
          />
          <AdUnit bannerType="bannerMain" aria-label="All Star page ad" />
          <AllStarBoxscore />
        </VoteHeadSection>
        <AllStarContainer />
      </RootCon>
    </>
  )
}

export default AllStar
